import React from 'react';
import AssessmentPage from './AssessmentPage';
import { ASSESSMENTS } from './assessmentConfig';

const CatfishingRomanceAssessment = (props) => (
  <AssessmentPage assessment={ASSESSMENTS['catfishing-romance']} {...props} />
);

export default CatfishingRomanceAssessment;
